import { Feedback } from "@/components/Feedback";
import { BfFeedbackComponent } from "@/lib/api/models";
import { destroyEverything } from "@/lib/client";
import { Toast } from "@/lib/toast";
import {
    Button,
    Form,
    FormTextAreaField,
    FormTextField,
    useForm,
} from "@disasterscience/scaffoldy";

type Props = {
    errorName: string;
    errorStack?: string;
    showFeedback?: boolean;
};

export const FriendlyError = (props: Props) => {
    const form = useForm<Props>({
        defaultValues: props,
    });

    return (
        <>
            <div className="tw:space-y-2">
                <h1>💥 An error occurred</h1>

                <div>
                    Please see our{" "}
                    <a href="https://dstr.to/JQmvDY" target="_blank" rel="noreferrer">
                        Frequently Asked Questions
                    </a>{" "}
                    page which might help you quicker than we can respond.{" "}
                </div>

                <div>
                    If the error continues, please submit feedback or email us at hello@bushfire.io.
                </div>

                {props.showFeedback ? (
                    <>
                        <Feedback
                            feedbackComponent={BfFeedbackComponent.error}
                            feedbackPrompt="What did you do just before the error occurred?"
                            extraContentToAppend={"\nStack: " + props.errorStack}
                            redirectAfterSubmitting
                            hideEmailPrompt
                        />
                    </>
                ) : (
                    <>
                        <Form {...form}>
                            <div className="tw:space-y-2">
                                <FormTextField
                                    name="errorName"
                                    type="text"
                                    control={form.control}
                                    disabled
                                />

                                <FormTextAreaField
                                    name="errorStack"
                                    type="text"
                                    control={form.control}
                                    disabled
                                />

                                <div className="tw:flex tw:gap-2">
                                    <a href="/">
                                        <Button>Return Home</Button>
                                    </a>

                                    <Button
                                        onClick={(def) => {
                                            Toast.info("The app will reset in 5 seconds.");

                                            setTimeout(async () => {
                                                destroyEverything()
                                                    .finally(() => {
                                                        window.location.href = "/";
                                                    })
                                                    .catch((e) => {
                                                        console.error(e);
                                                        window.location.href = "/";
                                                    });
                                            }, 5000);

                                            setTimeout(() => {
                                                window.location.href = "/";
                                            }, 15000);

                                            def.preventDefault();
                                        }}
                                    >
                                        Reset App
                                    </Button>
                                </div>
                            </div>
                        </Form>
                    </>
                )}
            </div>
        </>
    );
};
